import { useEffect, useState } from "react";
import "./ProviderModal.css";
import { getUserSuccessRate } from "../../../config/LiveApi";
import { Close } from "@mui/icons-material";

const UserModal = ({ setShowModal }) => {
  const [providerData, setProviderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [minutes, setMinutes] = useState(60)
  const [debouncedMinutes, setDebouncedMinutes] = useState(60);

    useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMinutes(minutes);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [minutes]);

    const fetchData = async (min) => {
      try {
        const response = await getUserSuccessRate(min);
        if (response?.status) {
          setProviderData(response.data || []);
        }
      } catch (err) {
        console.error("Error fetching provider success rate:", err);
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => {
    fetchData(debouncedMinutes);
  }, [debouncedMinutes]);

  return (
    <div className="overlay-provider-success">
      <div className="modal-provider-success">
        <div style={{display:"flex" , alignItems:"center",justifyContent:"space-between"}}>
          <div/>
          <h3 className="title-provider-success">📊 User Success Rate</h3>
          <div className="buttons-provider-success">
              <Close
                onClick={() => setShowModal(false)}
                className="close-btn-provider-success"
              />
              </div>
        </div>
        {/* Minutes Input */}
        <div className="filter-provider-success">
          <label htmlFor="minutesInput">Enter Minutes: </label>
          <input
            id="minutesInput"
            type="number"
            value={minutes}
            min="1"
            onChange={(e) => setMinutes(Number(e.target.value))}
            className="input-provider-success"
          />
        </div>


        <div className="table-wrapper-provider-success">
          <table className="table-provider-success">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Merchant Name</th>
                <th>Total Count</th>
                <th>Total Payin</th>
                <th>Success Count</th>
                <th>Processing Count</th>
                <th>Failed Count</th>
                <th>Success Rate (%)</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="no-data-provider-success">
                    Loading...
                  </td>
                </tr>
              ) : providerData && providerData.length > 0 ? (
                providerData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.alias ?? item?.id ?? "N/A"}</td>
                    <td>{item.totalTransactions || 0}</td>
                    <td>{Number(item.totalPayin).toFixed(2) || 0}</td>
                    <td className="success-provider-success">
                      {item.successCount || 0}
                    </td>
                    <td className="processing-provider-success">
                      {item.processingCount || 0}
                    </td>
                    <td className="failed-provider-success">
                      {item.failedCount || 0}
                    </td>
                    <td>{item.successRatePercent || 0}%</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-data-provider-success">
                    No User data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default UserModal;
